/** @format */

// @ts-nocheck
import Vue from 'vue';
import axios from 'axios';
import config from '../config/config';
import { notificationBus } from '@/libs/notificationBus';
// -------------------- AUTH --------------------
const token = localStorage.getItem('user-token');
if (token) {
  axios.defaults.headers.common['Authorization'] = token;
}

axios.defaults.baseURL = config.baseUrl;

// -------------------- CACHE --------------------
const CACHE_TTL = 10000; // 10 секунд
const cache = new Map();

// -------------------- REQUEST INTERCEPTOR --------------------
axios.interceptors.request.use((config) => {
  if (!config.cache) return config;

  const key = JSON.stringify({
    url: config.url,
    method: config.method,
    params: config.params,
    data: config.data,
  });

  config.__cacheKey = key;

  const cached = cache.get(key);

  // 🔁 если уже есть pending запрос — возвращаем его
  if (cached?.promise) {
    config.adapter = () => cached.promise;
    return config;
  }

  // 🧠 если есть валидный кэш
  if (cached && Date.now() - cached.time < CACHE_TTL) {
    config.adapter = () =>
      Promise.resolve({
        data: cached.data,
        status: 200,
        statusText: 'OK',
        headers: {},
        config,
        request: {},
      });
    return config;
  }

  // ⏳ создаем pending promise
  let resolvePromise;
  const promise = new Promise((resolve) => {
    resolvePromise = resolve;
  });

  cache.set(key, { promise });

  config.__resolveCache = resolvePromise;

  return config;
});

// -------------------- RESPONSE INTERCEPTOR --------------------
axios.interceptors.response.use(
  (response) => {
    const key = response.config.__cacheKey;

    if (key && response.config.cache) {
      const item = cache.get(key);

      // завершаем pending
      if (item?.promise && response.config.__resolveCache) {
        response.config.__resolveCache({
          data: response.data,
          status: response.status,
          statusText: response.statusText,
          headers: response.headers,
          config: response.config,
          request: response.request,
        });
      }

      // записываем кэш
      cache.set(key, {
        data: response.data,
        time: Date.now(),
      });
    }

    return response;
  },
  function (err) {
    // ❗ если ошибка — удаляем pending кэш
    const key = err?.config?.__cacheKey;
    if (key) {
      cache.delete(key);
    }

    return new Promise(function (resolve, reject) {
      if (!err?.response?.status) {
      } else if (err.response.status === 400) {
        if (err.response.data?.message) {
          throw err.response;
        }
      } else if (err.response.status === 403) {
        if (err.response.config.url === '/signup/get_profile' || !true) {
          localStorage.removeItem('user-token');
          localStorage.removeItem('user-profile');
          window.location.href = '/';
        } else {
          throw err.response;
        }
      } else if (err.response.status === 500) {
        notificationBus.$emit('show-info', {
          type: 'error',
          text: err.response.data?.message || 'Ошибка сервера',
        });
        //notificationBus.$store.dispatch('auth/logout');
        throw err.response;
      }
      throw err;
    });
  },
);

// -------------------- VUE --------------------
Vue.prototype.$axios = axios;

export default axios;
